const slugMapping = {
  "acqua-di-parma": "Acqua di Parma",
  "anna-new-york": "ANNA New York",
  "ark-fine-jewelry": "ARK Fine Jewelry",
  "atp-atelier": "ATP Atelier",
  "az-factory": "AZ Factory",
  "ba-sh": "ba&sh",
  beautystat: "BeautyStat",
  "ben-amun": "Ben-Amun",
  "bird-knoll": "Bird & Knoll",
  bvlgari: "BVLGARI",
  bytimo: "byTiMo",
  caalo: "Caalo",
  "cherut-fine-jewelry": "Chérut Fine Jewelry",
  "colbert-md": "Colbert MD",
  "d-s-durga": "D.S. & DURGA",
  "derm-institute": "DERM iNSTITUTE",
  "dr-barbara-sturm": "Dr. Barbara Sturm",
  femmue: "FEMMUE",
  healthyline: "HealthyLine",
  heurueh: "HEURUEH",
  "jac-jo": "Jac + Jo",
  "jia-jia": "JIA JIA",
  "joes-jeans": "Joe's Jeans",
  "kimberly-mcdonald": "Kimberly McDonald",
  "l-objet": "L'Objet",
  "la-doublej": "La DoubleJ",
  "lab-to-beauty": "Lab to Beauty",
  "larkspur-hawk": "Larkspur & Hawk",
  lvhr: "LVHR",
  "macrene-actives": "MACRENE Actives",
  marei1998: "Marei1998",
  "mita-eyewear": "MITA Eyewear",
  "mks-jewellery": "MKS Jewellery",
  "mz-skin": "MZ Skin",
  nevernot: "NeverNoT",
  nion: "NION",
  "olympia-le-tan": "Olympia Le-Tan",
  oxomio: "OXOMIO",
  "preen-by-thornton-bregazzi-home": "Preen by Thornton Bregazzi Home",
  "rag-bone": "rag & bone",
  revive: "RéVive",
  "royce-new-york": "ROYCE New York",
  "s-joon": "S.Joon",
  "sachin-and-babi": "Sachin and Babi",
  semsem: "SemSem",
  "short-suite": "Short & Suite",
  shymi: "SHYMI",
  "sio-beauty": "SiO Beauty",
  "solid-striped": "Solid & Striped",
  strialite: "STRIALITE",
  "stubbs-wootton": "Stubbs & Wootton",
  "jewelry-watches": "Jewelry & watches",
  "home-gifts": "Home & gifts",
  "bags-accessories": "Bags & accessories",
  "bath-body": "Bath & body",
  "lingerie-sleepwear": "Lingerie & sleepwear",
  "coats-jackets": "Coats & jackets",
  "dining-entertaining": "Dining & entertaining",
  "socks-tights": "Socks & tights",
  "tools-accessories": "Tools & accessories",
  "gloves-scarves": "Gloves & scarves",
  "wallets-cardholders": "Wallets & cardholders",
  "jumpsuits-rompers":"Jumpsuits & rompers",
  "puffer-quilted": "Puffer & quilted",
  "joggers-sweatpants": "Joggers & sweatpants",
  "sweatshirt-hoodies": "Sweatshirt & hoodies",
  "chains-stands": "Chains & strands",
  "mules-slides": "Mules & slides",
  "moisturizer-creams": "Moisturizer & creams",
  "hoops-huggies": "Hoops & huggies",
  "bras-panties": "Bras & panties",
  "loafers-oxfords": "Loafers & oxfords",
  "crossbody-shoulder": "Crossbody & shoulder",
  "Bangles-cuffs": "Bangles & cuffs",
  "double-breasted": "Double-breasted",
  "decorative-pillows-throws": "Decorative pillows & throws",
  "bable-linens-accessories": "Table linens & accessories",
  "candles-home-fragrances": "Candles & home fragrances",
  "hair-masks-treatments": "Hair masks & treatments",
  "office-desk-accessories": "Office & desk accessories",
  "one-piece":"One-Piece",
  "cover-ups":"Cover-Ups",
  "r-co": "R+Co",
  "spinelli-kilcollin":"Spinelli kilcollin",
  "skinny-leg": "Skinny leg",
  "straight-leg": "Straight leg",
  "wide-leg": "Wide leg",
  "tank-cami": "Tank & cami",
  "knee-high": "Knee-high",
  "over-the-knee": "Over-the-knee",
  "watch-winders":"Watch winders",
  "cat-eye":"Cat-eye",
  "cleanser-exfoliant":"Cleanser & exfoliant",
  "bar-wine-accessories":"Bar & wine accessories",
  "bowls-trays":"Bowls & trays",
  "dr-lara-devgan": "Dr. Lara Devgan",
  "dr-loretta": "Dr. Loretta",
  "the-vampires-wife": "The Vampire's Wife",
  "soia-kyo": "Soia & Kyo",
  "maha-morena": "MÄHA & MORENA",
  "stripe-stare": "Stripe & Stare",
  "ameon-skin":"AMEŌN Skin",
  "yvonne-leon":"Yvonne Léon",
  "mayle-vasquez":"Maylé Vásquez",
  "verde-limon":"Verde Limón",
  "vahy": "Váhy",
  "latelier-nawbar": "L'Atelier Nawbar",
  "mor%C3%A9-noir": "Moré noir",
  "more-noir": "Moré noir",
  "eera":"EÉRA",
  "knee-high-boots": "Knee-high Boots",
  "demi-fine-jewelry": "Demi-fine jewelry",
  "demi-fine-earrings": "Demi-fine earrings",
  "demi-fine-necklaces": "Demi-fine necklaces",
  "demi-fine-rings": "Demi-fine rings",
  "demi-fine-bracelets": "Demi-fine bracelets",
  "demi-fine-anklets": "Demi-fine anklets"
  // "e%C3%A9ra":"EÉRA",
};

export const getSlug = async (slug) => {
  if (!slug) return "";
  slug = slug.toLowerCase();
  slug = slug.split(",");
  slug.forEach((value, i) => {
    if (slugMapping[value]) {
      slug[i] = slugMapping[value];
    } else {
      let subValue = value.replaceAll("-", " ").split(" ");
      subValue[0] = subValue[0].charAt(0).toUpperCase() + subValue[0].slice(1);
      subValue = subValue.join(" ");
      slug[i] = subValue;
    }
  });
  return slug.join(",");
};

export const generateSlug = async (slug) => {
  if (!slug) return "";
  // if value contains space replace it with "-" for eg: "eric-buterbaugh-los angeles" to "eric-buterbaugh-los-angeles"
  let slugReturn = slug.toLowerCase().replace(" ", "-").replace(" ", "-").replace(/ /g, '-');
  Object.entries(slugMapping).map(([key, value]) => {
    if(slug.toLowerCase() === value.toLowerCase()) {
       slugReturn = key;
    }
  })
 
  return slugReturn ;
}

export const buildLink = async (type, category, subcategory) => {
  let link = process.env.NETLIFY_URL;
  let slug = await generateSlug(type);
  
  if (type) {
    if(type.toLowerCase() === 'clothing' || type.toLowerCase() === 'shoes' || type.toLowerCase() === 'bags & accessories') {
      link = `${link}/women/${slug}`;
    } else {
      link = `${link}/${slug}`;
    }
    if (category) {
      slug = await generateSlug(category);
      link = `${link}/${slug}`;
      if (subcategory) {
        slug = await generateSlug(subcategory);
        link = `${link}/${slug}`;
      }
    }
  }
  return link;
};

export function hasSpecialCharacters(urlPath) {
  const specialCharPattern =  /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  return specialCharPattern.test(urlPath);
}

export function generateSlugRegex(str) {
  if (str === "d-s-durga") {
    return "ds-durga";
  }
  if (str === "s-joon") {
    return "sjoon";
  }
  if (str === "l-objet") {
    return "lobjet";
  }

  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g,"")                     //accent char to normal
    .replaceAll(/[&\+\/+\s]/g,"-")                                                       //Replace + & / space with -
    .replace(/[^a-zA-Z0-9-]/g, '')                                                       //Remove all special chars except -
    .replace(/^-+|-+$|(-)+/gm, "$1")                                                 //Remove multiple - only keep 1
    .replace(/[A-Z]/g,(match)=> match.toLowerCase());  
 
  return str;
 }
